import { gql } from "@apollo/client";

export const GET_STUDENT_BY_ACADEMIC_YEAR = gql`
  query GetStudentByAcademicYearWeb($academicYearId: ID) {
    getStudentByAcademicYearWeb(academicYearId: $academicYearId) {
      _id
      profileImg
      englishName
      familyEnglishName
      studentEnglishName
      firstName
      lastName
    }
  }
`;
